var NavList = {
  adminLogisticsNav: [{ //管理员货代导航
    active: false,
    icon: "fa-university",
    title: "首页统计",
    url: "AdminHome"
  }, {
    active: false,
    icon: "fa-xing-square",
    title: "会员列表",
    url: "Member"
  }, {
    active: false,
    icon: "fa-paypal",
    title: "订单列表",
    url: "MemberOrder",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "全部",
      url: "MemberOrder?te=0",
    }, {
      active: false,
      icon: "xe6f6",
      title: "待打包",
      url: "MemberOrder?te=1",
    }, {
      active: false,
      icon: "xe6f5",
      title: "已完成",
      url: "MemberOrder?te=2",
    }, {
      active: false,
      icon: "xe6a3",
      title: "异常",
      url: "MemberOrder?te=3",
    }, {
      active: false,
      icon: "xe6b7",
      title: "已关闭",
      url: "MemberOrder?te=4",
    }]
  }, {
    active: false,
    icon: "fa-university",
    title: "店铺列表",
    url: "AminShop"
  }, {
    active: false,
    icon: "fa-shield",
    title: "充值记录",
    url: "MemberRechargeLog"
  }, {
    active: false,
    icon: "fa-tasks",
    title: "订单统计",
    url: "OrderStatistics"
  }, {
    active: false,
    icon: "fa-cubes",
    title: "打包统计",
    url: "PackingStatistics"
  }, {
    active: false,
    icon: "fa-hashtag",
    title: "退货列表",
    url: "Return"
  }, {
    active: false,
    icon: "fa-cubes",
    title: "快递检查",
    url: "PackageExamine"
  }, {
    active: false,
    icon: "fa-inbox",
    title: "库存管理",
    url: "Stock",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "库存列表",
      url: "Stock",
    }, {
      active: false,
      icon: "xe6f6",
      title: "出入库",
      url: "StockRecord",
    }]
  }, {
    active: false,
    icon: "fa-registered",
    title: "扫码列表",
    url: "LogList"
  }],
  adminProductNav: [{ //管理员上架导航
    active: false,
    icon: "fa-cloud-upload",
    title: "首页统计",
    url: "AdminProHome"
  }, {
    active: false,
    icon: "fa-xing-square",
    title: "会员列表",
    url: "Member"
  }, {
    active: false,
    icon: "fa-hashtag",
    title: "在线记录",
    url: "OnlineRecord"
  }, {
    active: false,
    icon: "fa-paypal",
    title: "套餐管理",
    url: "Package",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "套餐添加",
      url: "Package",
    }, {
      active: false,
      icon: "xe6f6",
      title: "套餐设置",
      url: "PackageSet",
    }]
  }, {
    active: false,
    icon: "fa-xing-square",
    title: "采集列表",
    url: "AdminCol"
  }, {
    active: false,
    icon: "fa-inbox",
    title: "店铺商品",
    url: "AdminProduct"
  }, {
    active: false,
    icon: "fa-globe",
    title: "全球商品",
    url: "AdminGlobal"
  }, {
    active: false,
    icon: "fa-shield",
    title: "套餐记录",
    url: "PackageLog"
  },{
    active: false,
    icon: "fa-star-half-o",
    title: "推广返利",
    url: "ProductPromote",
    subMenu: [{
      active: false,
      icon: "xe6f6",
      title: "返佣记录",
      url: "RebateRecord",
    }, {
      active: false,
      icon: "fa-book",
      title: "提现记录",
      url: "ProductWithdraw"
    }]
  }],
  adminFinanceNav: [{ //管理员金融导航
    active: false,
    icon: "fa-cloud-upload",
    title: "首页统计",
    url: "AdminFinHome"
  }, {
    active: false,
    icon: "fa-xing-square",
    title: "资方列表",
    url: "UserList"
  }, {
    active: false,
    icon: "fa-tasks",
    title: "虾皮订单",
    url: "FinOrder"
  }, {
    active: false,
    icon: "fa-paypal",
    title: "募集列表",
    url: "Raise"
  }, {
    active: false,
    icon: "fa-shield",
    title: "投入记录",
    url: "Invest"
  }, {
    active: false,
    icon: "fa-book",
    title: "提现记录",
    url: "Withdraw"
  }],
  deliverymanNav: [{ //打包员导航
    active: false,
    icon: "fa-university",
    title: "首页统计",
    url: "DeHome"
  }, {
    active: false,
    icon: "fa-paypal",
    title: "订单列表",
    url: "DeOrder",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "全部",
      url: "DeOrder?te=0",
    }, {
      active: false,
      icon: "xe6f6",
      title: "待打包",
      url: "DeOrder?te=1",
    }, {
      active: false,
      icon: "xe6f5",
      title: "已完成",
      url: "DeOrder?te=2",
    }, {
      active: false,
      icon: "xe6a3",
      title: "异常",
      url: "DeOrder?te=3",
    }, {
      active: false,
      icon: "xe6b7",
      title: "已关闭",
      url: "DeOrder?te=4",
    }]
  }, {
    active: false,
    icon: "fa-hashtag",
    title: "退货列表",
    url: "Return"
  }, {
    active: false,
    icon: "fa-cubes",
    title: "快递检查",
    url: "PackageExamine"
  }, {
    active: false,
    icon: "fa-inbox",
    title: "库存管理",
    url: "Stock",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "库存列表",
      url: "Stock",
    }, {
      active: false,
      icon: "xe6f6",
      title: "出入库",
      url: "StockRecord",
    }]
  }, {
    active: false,
    icon: "fa-registered",
    title: "扫码列表",
    url: "LogList"
  }],
  autonomyDeliverymanNav: [{ //外放打包员导航
    active: false,
    icon: "fa-university",
    title: "首页统计",
    url: "DeHome"
  }, {
    active: false,
    icon: "fa-paypal",
    title: "订单列表",
    url: "DeOrder",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "全部",
      url: "DeOrder?te=0",
    }, {
      active: false,
      icon: "xe6f6",
      title: "待打包",
      url: "DeOrder?te=1",
    }, {
      active: false,
      icon: "xe6f5",
      title: "已完成",
      url: "DeOrder?te=2",
    }, {
      active: false,
      icon: "xe6a3",
      title: "异常",
      url: "DeOrder?te=3",
    }, {
      active: false,
      icon: "xe6b7",
      title: "已关闭",
      url: "DeOrder?te=4",
    }]
  }, {
    active: false,
    icon: "fa-hashtag",
    title: "退货列表",
    url: "Return"
  }, {
    active: false,
    icon: "fa-shield",
    title: "快递检查",
    url: "PackageExamine"
  }, {
    active: false,
    icon: "fa-cubes",
    title: "打包统计",
    url: "DePackingStatistics"
  }, {
    active: false,
    icon: "fa-inbox",
    title: "库存管理",
    url: "Stock",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "库存列表",
      url: "Stock",
    }, {
      active: false,
      icon: "xe6f6",
      title: "出入库",
      url: "StockRecord",
    }]
  }, {
    active: false,
    icon: "fa-registered",
    title: "扫码列表",
    url: "LogList"
  }],
  logisticsNav: [{ //用户-货代
    active: false,
    icon: "fa-desktop",
    title: "首页统计",
    url: "UserHomePage"
  }, {
    active: false,
    icon: "fa-university",
    title: "店铺管理",
    url: "Shop"
  }, {
    active: false,
    icon: "fa-xing-square",
    title: "订单管理",
    url: "Order",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "全部",
      url: "Order?te=0",
    }, {
      active: false,
      icon: "xe6f4",
      title: "未提交",
      url: "Order?te=1",
    }, {
      active: false,
      icon: "xe6f6",
      title: "已提交",
      url: "Order?te=2",
    }, {
      active: false,
      icon: "xe6f5",
      title: "已完成",
      url: "Order?te=3",
    }, {
      active: false,
      icon: "xe6a3",
      title: "异常订单",
      url: "Order?te=4",
    }, {
      active: false,
      icon: "xe6b7",
      title: "已关闭",
      url: "Order?te=5",
    }]
  }, {
    active: false,
    icon: "fa-paypal",
    title: "立即充值",
    url: "Recharge"
  }, {
    active: false,
    icon: "fa-shield",
    title: "充值记录",
    url: "RechargeRecord"
  }, {
    active: false,
    icon: "fa-book",
    title: "消费记录",
    url: "ConsumptionRecord"
  }, {
    active: false,
    icon: "fa-star-half-o",
    title: "推广返利",
    url: "Promote"
  }, {
    active: false,
    icon: "fa-hashtag",
    title: "退货列表",
    url: "Return"
  }, {
    active: false,
    icon: "fa-cubes",
    title: "快递检查",
    url: "PackageExamine"
  }, {
    active: false,
    icon: "fa-inbox",
    title: "库存管理",
    url: "Stock",
    subMenu: [{
      active: true,
      icon: "xe6cb",
      title: "库存列表",
      url: "Stock",
    }, {
      active: false,
      icon: "xe6f6",
      title: "出入库",
      url: "StockRecord",
    }]
  }],
  productNav: [{ //用户-上架
    active: false,
    icon: "fa-desktop",
    title: "首页统计",
    url: "HomePage"
  }, {
    active: false,
    icon: "fa-university",
    title: "店铺管理",
    url: "Shops"
  }, {
    active: false,
    icon: "fa-anchor",
    title: "定价模板",
    url: "Pricing"
  }, {
    active: false,
    icon: "fa-cloud-download",
    title: "采集列表",
    url: "Col"
  }
  // , {
  //   active: false,
  //   icon: "fa-star",
  //   title: "店铺商品",
  //   url: "Product"
  // }
  , {
    active: false,
    icon: "fa-globe",
    title: "全球商品",
    url: "Global"
  }, {
    active: false,
    icon: "fa-diamond",
    title: "订购中心",
    url: "Servicelimit"
  }, {
    active: false,
    icon: "fa-registered",
    title: "已购服务",
    url: "Purchased"
  }, {
    active: false,
    icon: "fa-file-image-o",
    title: "图片空间",
    url: "Space"
  }],
  manageNav: [{ //用户-上架
    active: false,
    icon: "fa-desktop",
    title: "首页统计",
    url: "ManageHomePage"
  }, {
    active: false,
    icon: "fa-paypal",
    title: "佣金设置",
    url: "ShopManage"
  }, {
    active: false,
    icon: "fa-star",
    title: "商品管理",
    url: "ProductManage"
  }, {
    active: false,
    icon: "fa-xing-square",
    title: "订单管理",
    url: "OrderManage"
  }]
}

export {
  NavList
}



//////////////////
// WEBPACK FOOTER
// ./static/js/LeftNav.js
// module id = null
// module chunks = 